import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";

import "./styles.css";

interface Props {
  id: string;
  className?: string;
}

export const CarouselNavigationButtons = ({ id, className }: Props) => {
  return (
    <>
      <button id={`${id}-button-prev`} className={`carousel-navigation-button prev ${className || ""}`}>
        <MdArrowBackIos size="1rem" className="ml-1" />
      </button>

      <button id={`${id}-button-next`} className={`carousel-navigation-button next ${className || ""}`}>
        <MdArrowForwardIos size="1rem" />
      </button>
    </>
  );
};
